import React from 'react';
import PropertyGrid from '../../pages/modals/PropertyGrid';

interface PropertySectionProps {
  topProperties: any;
  hasMore: boolean;
  fetchMore: () => void;
}

const PropertySection: React.FC<PropertySectionProps> = ({
  topProperties,
  hasMore,
  fetchMore
}) => {
  return (
    <>
      {topProperties?.properties?.length > 0 && (
        <PropertyGrid
          className={`properties-grid ${
            topProperties?.properties?.length
              ? 'grid-onData'
              : 'grid-onEmpty'
          }`}
          items={topProperties?.properties ?? []}
          hasMore={hasMore}
          fetchMore={fetchMore}
        />
      )}
    </>
  );
};

export default PropertySection;
